import { render, staticRenderFns } from "./pageheader_component.vue?vue&type=template&id=8c8c2562&scoped=true&"
import script from "./pageheader_component.vue?vue&type=script&lang=js&"
export * from "./pageheader_component.vue?vue&type=script&lang=js&"
import style0 from "./pageheader_component.vue?vue&type=style&index=0&id=8c8c2562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8c2562",
  null
  
)

export default component.exports